import { render, staticRenderFns } from "./CameraPageShootCardAutoMyNumberCardDiagonal2.vue?vue&type=template&id=3ab37bcc&"
import script from "./CameraPageShootCardAutoMyNumberCardDiagonal2.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootCardAutoMyNumberCardDiagonal2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports